import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const PortalRootContext = createContext(null);
export const PortalRootProvider = ({ portalRoot = null, children, }) => {
    return (_jsx(PortalRootContext.Provider, { value: portalRoot, children: children }));
};
export const usePortalRoot = () => {
    return useContext(PortalRootContext);
};
//# sourceMappingURL=portalRootContext.js.map